import type {
  JourneyPlanRequest,
  JourneyPlanResponse,
  MapLayersResponse,
  PlaceReverseResponse,
  PlaceSearchRequest,
  PlaceSearchResponse,
  RoutingStatusResponse,
  StopDeparturesRequest,
  StopDeparturesResponse,
} from '@lousada/shared';
import { getJson, postJson } from './client.js';

export function searchPlaces(
  request: PlaceSearchRequest,
  signal?: AbortSignal,
): Promise<PlaceSearchResponse> {
  return postJson<PlaceSearchResponse>('/api/v1/places/search', request, signal);
}

export function reversePlace(
  latitude: number,
  longitude: number,
  signal?: AbortSignal,
): Promise<PlaceReverseResponse> {
  return postJson<PlaceReverseResponse>('/api/v1/places/reverse', { latitude, longitude }, signal);
}

export function planJourney(
  request: JourneyPlanRequest,
  signal?: AbortSignal,
): Promise<JourneyPlanResponse> {
  return postJson<JourneyPlanResponse>('/api/v1/journeys/plan', request, signal);
}

export function fetchRoutingStatus(signal?: AbortSignal): Promise<RoutingStatusResponse> {
  return getJson<RoutingStatusResponse>('/api/v1/routing/status', signal);
}

export function fetchMapLayers(signal?: AbortSignal): Promise<MapLayersResponse> {
  return getJson<MapLayersResponse>('/api/v1/map/layers', signal);
}

export function fetchStopDepartures(
  request: StopDeparturesRequest,
  signal?: AbortSignal,
): Promise<StopDeparturesResponse> {
  return postJson<StopDeparturesResponse>('/api/v1/stops/departures', request, signal);
}
